import isNumber from 'lodash/isNumber';
import toNumber from 'lodash/toNumber';
export class CurrencyUtil {
    static parseCurrency(stringOrNumber, withCurrency = false) {
        const value = toNumber(stringOrNumber);
        if (isNumber(value) && !Number.isNaN(value)) {
            if (withCurrency) {
                return new Intl.NumberFormat('ja-JP', {
                    style: 'currency',
                    currency: 'JPY',
                }).format(value);
            }
            return new Intl.NumberFormat('ja-JP').format(value);
        }
        return undefined;
    }
    static formatAmount(stringOrNumber) {
        const value = toNumber(stringOrNumber);
        if (isNumber(value) && !Number.isNaN(value)) {
            return new Intl.NumberFormat('ja-JP', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(value);
        }
        return undefined;
    }
}
